var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('div',[_c('OrderDetails'),_c('ProductsList')],1),_c('SidebarFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }